import {useTranslation} from "react-i18next";
import React from "react";
import Title from "../../components/Title";
import Block from "../../components/Block";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Table from "../../components/tables/Table";
import Pagination from "../../components/tables/Pagination";
import useAsyncTable from "../../components/tables/useAsyncTable";
import FilterButton, {FilterGroup} from "../../components/FilterButton";
import { useGetPakitoFiltersQuery, useLazyGetPakitoQuery } from "../../api/pakitoApiSlice";

function PakitoList(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const {data: filters, isSuccess} = useGetPakitoFiltersQuery();
  const nbRatingsOptions = isSuccess ? filters.nb_ratings.map(el => ({label: el.toLocaleString('en-US') + '+', value: el})) : []
  const installOptions = isSuccess ? filters.installs : []
  const categories = isSuccess ? filters.categories.map(el => ({label: el.label, value: el.id})) : []
  const [pakitoList] = useLazyGetPakitoQuery()

  const columns = [
    {
      Header: 'Name',
      accessor: 'app_name',
      disableFilters: false
    },
    {
      Header: 'Bundle Id',
      accessor: 'bundle_id',
      disableFilters: false
    },
    {
      Header: 'Category',
      accessor: 'category',
      disableFilters: false,
      filter: 'select',
      options: categories,
      filter_searchable: true
    },
    {
      Header: 'Developer',
      accessor: 'developer_name',
      disableFilters: false
    },
    {
      Header: 'Ratings',
      accessor: 'nb_ratings',
      disableFilters: false,
      filter: 'select',
      options: nbRatingsOptions
    },
    {
      Header: 'Downloads',
      accessor: 'installs',
      disableFilters: false,
      filter: 'select',
      options: installOptions
    },
    {
      Header: 'permissions_ids',
      accessor: 'permissions_ids'
    }
  ];

  const onRowClick = (data) => {
    history.push(`/pakito/${data.id}`);
  }

  const {
    tableProps,
    paginationProps,
    tableFilterProps
  } = useAsyncTable({
    sortable: true,
    paginate: true,
    callback: pakitoList,
    hiddenColumns: ['permissions_ids'],
    initialFilters: [{id: "permissions_ids", value: [101]}]
  })

  return(
    <>
      <Title main={t("menu.pakito")} />
      <FilterGroup {...tableFilterProps}>
        <FilterButton
          title={"Permissions"}
          options={[{value: 101, label: "Background Loc"}, {value: 32, label: "Bluetooth"}]}
          selected={[101]}
          search={false}
          includeAll={false}
          nullIfAllSelected={false}
          name="permissions_ids"/>
      </FilterGroup>
      <Block className="mb-0" style={{overflow: "initial"}}>
        <Table
          columns={columns}
          onRowClick={onRowClick}
          {...tableProps}/>
      </Block>
      <Pagination {...paginationProps}/>
    </>
  )
}

export default PakitoList
